<template>
  <g>
    <path
      d="M4 5.34305C4 4.71187 4.51167 4.2002 5.14286 4.2002H9.29081C9.58549 4.2002 9.86878 4.31402 10.0815 4.51791L11.1685 5.5595C11.3812 5.76339 11.6645 5.87721 11.9592 5.87721H18.8571C19.4883 5.87721 20 6.38889 20 7.02007V18.4859C20 19.1171 19.4883 19.6288 18.8571 19.6288H5.14286C4.51168 19.6288 4 19.1171 4 18.4859V5.34305Z"
      fill="white"
    />
    <path
      d="M4 5.34305C4 4.71187 4.51167 4.2002 5.14286 4.2002H9.29081C9.58549 4.2002 9.86878 4.31402 10.0815 4.51791L11.1685 5.5595C11.3812 5.76339 11.6645 5.87721 11.9592 5.87721H18.8571C19.4883 5.87721 20 6.38889 20 7.02007V18.4859C20 19.1171 19.4883 19.6288 18.8571 19.6288H5.14286C4.51168 19.6288 4 19.1171 4 18.4859V5.34305Z"
      fill="url(#paint0_linear_939_1074)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.14286 4.7002C4.78782 4.7002 4.5 4.98801 4.5 5.34305V18.4859C4.5 18.8409 4.78782 19.1288 5.14286 19.1288H18.8571C19.2122 19.1288 19.5 18.8409 19.5 18.4859V7.02007C19.5 6.66503 19.2122 6.37721 18.8571 6.37721H11.9592C11.5356 6.37721 11.1284 6.21359 10.8225 5.9205L9.73559 4.87891C9.61592 4.76422 9.45656 4.7002 9.29081 4.7002H5.14286ZM3.5 5.34305C3.5 4.43573 4.23553 3.7002 5.14286 3.7002H9.29081C9.71441 3.7002 10.1216 3.86382 10.4275 4.15691L11.5144 5.1985C11.6341 5.31319 11.7934 5.37721 11.9592 5.37721H18.8571C19.7645 5.37721 20.5 6.11274 20.5 7.02007V18.4859C20.5 19.3932 19.7645 20.1288 18.8571 20.1288H5.14286C4.23553 20.1288 3.5 19.3932 3.5 18.4859V5.34305Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0003 9.27252H4.00034V8.27252H20.0003V9.27252Z"
      fill="#3E7DC0"
    />
    <rect x="1.5" y="14.0002" width="21" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M9.15234 20.2658C9.15234 20.62 9.0625 20.9351 8.88281 21.2111C8.70312 21.4846 8.44401 21.6981 8.10547 21.8517C7.76693 22.0028 7.36979 22.0783 6.91406 22.0783C6.53385 22.0783 6.21484 22.0523 5.95703 22.0002C5.69922 21.9455 5.43099 21.8517 5.15234 21.7189V20.3439C5.44661 20.495 5.7526 20.6135 6.07031 20.6994C6.38802 20.7827 6.67969 20.8244 6.94531 20.8244C7.17448 20.8244 7.34245 20.7853 7.44922 20.7072C7.55599 20.6265 7.60938 20.5236 7.60938 20.3986C7.60938 20.3205 7.58724 20.2528 7.54297 20.1955C7.5013 20.1356 7.43229 20.0757 7.33594 20.0158C7.24219 19.9559 6.98958 19.8335 6.57812 19.6486C6.20573 19.4793 5.92578 19.3153 5.73828 19.1564C5.55339 18.9976 5.41536 18.8153 5.32422 18.6096C5.23568 18.4038 5.19141 18.1603 5.19141 17.8791C5.19141 17.353 5.38281 16.9429 5.76562 16.6486C6.14844 16.3543 6.67448 16.2072 7.34375 16.2072C7.9349 16.2072 8.53776 16.3439 9.15234 16.6174L8.67969 17.8088C8.14583 17.564 7.6849 17.4416 7.29688 17.4416C7.09635 17.4416 6.95052 17.4767 6.85938 17.5471C6.76823 17.6174 6.72266 17.7046 6.72266 17.8088C6.72266 17.9208 6.77995 18.021 6.89453 18.1096C7.01172 18.1981 7.32682 18.3596 7.83984 18.5939C8.33203 18.8153 8.67318 19.0536 8.86328 19.3088C9.05599 19.5614 9.15234 19.8804 9.15234 20.2658Z"
      fill="#F8F8F8"
    />
    <path
      d="M14.1797 18.1057C14.1797 18.7437 13.9909 19.2372 13.6133 19.5861C13.2383 19.9325 12.7044 20.1057 12.0117 20.1057H11.5781V22.0002H10.0352V16.2892H12.0117C12.7331 16.2892 13.2747 16.4468 13.6367 16.7619C13.9987 17.077 14.1797 17.5249 14.1797 18.1057ZM11.5781 18.8478H11.8594C12.0911 18.8478 12.2747 18.7827 12.4102 18.6525C12.5482 18.5223 12.6172 18.3426 12.6172 18.1135C12.6172 17.728 12.4036 17.5353 11.9766 17.5353H11.5781V18.8478Z"
      fill="#F8F8F8"
    />
    <path
      d="M17.6094 22.0002H16.0664V17.551H14.6719V16.2892H19V17.551H17.6094V22.0002Z"
      fill="#F8F8F8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_939_1074"
        x1="12.6667"
        y1="3.34244"
        x2="12.6667"
        y2="11.9145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.49" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
